<template>
  <div id="ivsInformation" class="console">
    <div class="panel-block">
      <div class="columns">
        <div class="column">
          <b-field label="サーバーURL">
            <b-input
              type="text"
              id="ingestEndpoint"
              :value="ingestEndpoint"
              readonly
              expanded
            />
            <p class="control">
              <b-button
                class="button copybutton"
                @click="copyValue('ingestEndpoint')"
                >コピー</b-button
              >
            </p>
          </b-field>
        </div>
        <div class="column">
          <b-field label="ストリームキー">
            <b-input
              type="text"
              id="streamKey"
              :value="streamKey"
              readonly
              expanded
            />
            <p class="control">
              <b-button
                class="button copybutton"
                @click="copyValue('streamKey')"
                >コピー</b-button
              >
            </p>
          </b-field>
        </div>
      </div>
    </div>
    <div class="buttons">
      <b-button
        class="button"
        :disabled="isStreaming"
        @click.native="resetStreamKey"
      >
        ストリームキー更新
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IvsInformation',
  data() {
    return {
      isStreaming: false
    };
  },
  computed: {
    streamKey() {
      return this.$store.state.ivs.streamKey.value;
    },
    ingestEndpoint() {
      return this.$store.state.ivs.channel.ingestEndpoint
        ? `rtmps://${this.$store.state.ivs.channel.ingestEndpoint}:443/app/`
        : '';
    },
  },
  methods: {
    async resetStreamKey() {
      try {
        this.$store.dispatch('resetStreamKey', {
          userId: this.$store.state.auth.uid,
          channelArn: this.$store.state.user.ivsChannelArn,
          streamKeyArn: this.$store.state.user.ivsStreamKeyArn
        });
        this.$buefy.toast.open({
          message: 'ストリームキーがリセットされました。',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    copyValue(inputId) {
      const inputElement = document.querySelector(`#${inputId}`);
      inputElement.select();
      try {
        document.execCommand('copy');
        this.$buefy.toast.open({
          message: 'クリップボードにコピーされました。',
          type: 'is-success'
        });
      } catch (err) {
        this.$buefy.toast.open({
          message: err.message,
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/ivs-information.scss';
</style>
